import { render, staticRenderFns } from "./ju.vue?vue&type=template&id=610213db&scoped=true"
import script from "./ju.vue?vue&type=script&lang=js"
export * from "./ju.vue?vue&type=script&lang=js"
import style0 from "./ju.vue?vue&type=style&index=0&id=610213db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610213db",
  null
  
)

export default component.exports